const getHintMessage = (hint, equalizeFunction) => {
  if (!equalizeFunction) {
    return hint;
  }
  return '';
};

export default getHintMessage;
